import { brasaoImpressaoBase64 } from "@/assets/brasaoImpressaoBase64";
import { TIPO_INSPECAO } from "@/constants/TIPO_INSPECAO";
import { IAnaliseLaboratorial } from "@/interfaces/IAnaliseLaboratorial";
import { cpfMask } from "@/utils/cpfMask";
import dayjs from "dayjs";
import { forwardRef } from "react";
import styles from "./style.module.css";

interface ImpressaoAnaliseLaboratorialProps {
  marcadagua?: string;
  item: IAnaliseLaboratorial | null;
}

export const ImpressaoAnaliseLaboratorial = forwardRef<
  HTMLDivElement,
  ImpressaoAnaliseLaboratorialProps
>(({ marcadagua, item }, ref) => (
  <div ref={ref}>
    <div className="marcadagua">{marcadagua}</div>

    <div className={styles.analysisReport}>
      {/* Header Section */}
      <table className={styles.headerTable}>
        <thead>
          <tr>
            <th className={styles.logoSection}>
              <div className={styles.logo}>
                <img
                  src={brasaoImpressaoBase64}
                  alt="brasao"
                  style={{
                    width: 125,
                  }}
                />
              </div>
            </th>

            <th className={styles.instituteInfo}>
              <h1>INSTITUTO DE DEFESA AGROPECUÁRIA DO ESTADO DE MATO GROSSO</h1>

              <p>
                Rua Dep. José Alves Ribeiro, 1267 - Centro Político
                Administrativo | CEP: 78049-903 | Cuiabá - MT (65) 3613-6074
              </p>

              <h1>REQUISIÇÃO DE ANÁLISES LABORATORIAIS</h1>
            </th>

            <th className={styles.sectorInfo} style={{ width: "50%" }}>
              <div
                style={{
                  borderBottom: "1px solid black",
                  paddingLeft: "5px",
                  textAlign: "start",
                }}
              >
                <span>01 - SETOR</span>
              </div>
              <div
                className={styles.analysisTypes}
                style={{ borderBottom: "1px solid black", paddingBottom: 5 }}
              >
                <label>
                  <input
                    type="checkbox"
                    checked={item?.natureza === "MICROBIOLOGICA"}
                    readOnly
                  />{" "}
                  Microbiologia
                </label>
                <label>
                  <input
                    type="checkbox"
                    readOnly
                    checked={item?.natureza === "FISICOQUIMICO"}
                  />{" "}
                  Físico-Química
                </label>
                <label>
                  <input type="checkbox" readOnly /> RBQL
                </label>
              </div>

              <div className={styles.requestNumber}>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    textAlign: "start",
                    paddingLeft: "5px",
                  }}
                >
                  <span>02 - Nº DA SOLICITAÇÃO/ANO</span>
                </div>

                <div style={{ paddingTop: 5 }}>
                  <span>{item?.codigo}</span>
                </div>
              </div>
            </th>
          </tr>
        </thead>
      </table>

      {/* Client Information */}
      <table className={styles.dataTable}>
        <colgroup>
          {Array.from({ length: 10 }).map((_, index) => (
            <col key={index} style={{ width: "10%" }} />
          ))}
        </colgroup>

        <tbody>
          <tr>
            <td className={styles.fieldLabel} colSpan={3}>
              03 - ESTABELECIMENTO
            </td>
            <td className={styles.fieldLabel} colSpan={1}>
              04 -{" "}
              {item?.estabelecimento
                ? TIPO_INSPECAO[item.estabelecimento.tipoInspecao]
                : "SISE"}
            </td>
            <td className={styles.fieldLabel} colSpan={6}>
              05 - ENDEREÇO (LOGRADOURO/MUNICÍPIO/UF)
            </td>
          </tr>

          <tr>
            <td className={styles.fieldValue} colSpan={3}>
              {item?.estabelecimento.nome || ""}
            </td>
            <td className={styles.fieldValue} colSpan={1}>
              {item?.estabelecimento.numeroInspecao}
            </td>
            <td className={styles.fieldValue} colSpan={6}>
              {item?.estabelecimento.endereco.bairro}
              {", "}
              {item?.estabelecimento.endereco.logradouro}
              {", "}
              {item?.estabelecimento.endereco.municipio.nome} -{" "}
              {item?.estabelecimento.endereco.municipio.uf.sigla}
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={5}>
              06 - TELEFONE
            </td>
            <td className={styles.fieldLabel} colSpan={5}>
              07 - EMAIL
            </td>
          </tr>

          <tr>
            <td
              className={styles.fieldValue}
              colSpan={5}
              style={{ height: 20 }}
            >
              {" "}
            </td>
            <td className={styles.fieldValue} colSpan={5}>
              cispoa@indea.mt.gov.br
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={5}>
              08 - PRODUTO
            </td>

            <td className={styles.fieldLabel} colSpan={5}>
              09 - CATEGORIA
            </td>
          </tr>

          <tr>
            <td
              className={styles.fieldValue}
              colSpan={5}
              style={{ height: 20 }}
            >
              {item?.agua ? "Água" : item?.produto?.produto?.nome || ""}
            </td>
            <td className={styles.fieldValue} colSpan={5}>
              {""}
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={4}>
              10 - INFORMAÇÕES ADICIONAIS
            </td>
            <td className={styles.fieldLabel} colSpan={3}>
              11 - MARCA
            </td>
            <td className={styles.fieldLabel} colSpan={2}>
              12 - LOTE
            </td>
            <td className={styles.fieldLabel} colSpan={1}>
              13 - DATA FABRICAÇÃO
            </td>
          </tr>

          <tr>
            <td
              className={styles.fieldValue}
              colSpan={4}
              style={{ height: 20 }}
            >
              {item?.infAdicional || ""}
            </td>
            <td className={styles.fieldValue} colSpan={3}>
              {item?.marca?.nome || ""}
            </td>
            <td className={styles.fieldValue} colSpan={2}>
              {item?.lote || ""}
            </td>
            <td className={styles.fieldValue} colSpan={1}>
              {item?.dataFabricacao
                ? dayjs(item?.dataFabricacao).format("DD/MM/YYYY")
                : ""}
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={1}>
              14 - DATA VALIDADE
            </td>
            <td className={styles.fieldLabel} colSpan={2}>
              15 - TAMANHO DO LOTE
            </td>
            <td className={styles.fieldLabel} colSpan={2}>
              16 - LACRE
            </td>
            <td className={styles.fieldLabel} colSpan={3}>
              17 - LACRE CONTRA PROVA EMPRESA
            </td>

            <td className={styles.fieldLabel} colSpan={2}>
              18 - LACRE CONTRA PROVA SBE
            </td>
          </tr>

          <tr>
            <td
              className={styles.fieldValue}
              colSpan={1}
              style={{ height: 20 }}
            >
              {item?.dataValidade
                ? dayjs(item?.dataValidade).format("DD/MM/YYYY")
                : ""}
            </td>
            <td className={styles.fieldValue} colSpan={2}>
              {item?.tamanhoPartida || ""}
            </td>
            <td className={styles.fieldValue} colSpan={2}>
              {item?.lacre || ""}
            </td>
            <td className={styles.fieldValue} colSpan={3}>
              {item?.lacreCProvaEmp || ""}
            </td>

            <td className={styles.fieldValue} colSpan={2}>
              {item?.lacreCProvaSise || ""}
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={3}>
              19 - DATA DA COLETA DA AMOSTRA
            </td>

            <td className={styles.fieldLabel} colSpan={3}>
              20 - HORÁRIO DA COLETA DA AMOSTRA
            </td>

            <td className={styles.fieldLabel} colSpan={4}>
              21 - DATA DA REMESSA DA AMOSTRA
            </td>
          </tr>

          <tr>
            <td
              className={styles.fieldValue}
              colSpan={3}
              style={{ height: 20 }}
            >
              {item?.dataColeta
                ? dayjs(item?.dataColeta).format("DD/MM/YYYY")
                : ""}
            </td>

            <td className={styles.fieldValue} colSpan={3}>
              {item?.dataColeta ? dayjs(item?.dataColeta).format("HH:mm") : ""}
            </td>

            <td className={styles.fieldValue} colSpan={4}>
              {item?.dataRemessa
                ? dayjs(item?.dataRemessa).format("DD/MM/YYYY")
                : ""}
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={2}>
              22 - TEMPERATURA DA AMOSTRA NA COLETA
            </td>

            <td className={styles.fieldLabel} colSpan={8}>
              23 - CONDIÇÕES DA AMOSTRA NA COLETA
            </td>
          </tr>

          <tr>
            <td
              className={styles.fieldValue}
              colSpan={2}
              style={{ height: 20 }}
            >
              {item?.temperaturaColeta || ""}
            </td>
            <td className={styles.fieldValue} colSpan={8}>
              <div className={styles.checkboxes}>
                <label>
                  <input
                    type="checkbox"
                    readOnly
                    checked={item?.condicaoAmostra === "CONGELADO"}
                  />{" "}
                  congelado
                </label>
                <label>
                  <input
                    type="checkbox"
                    readOnly
                    checked={item?.condicaoAmostra === "CRISTAIS"}
                  />{" "}
                  cristais de gelo
                </label>
                <label>
                  <input
                    type="checkbox"
                    readOnly
                    checked={item?.condicaoAmostra === "RESFRIADO"}
                  />{" "}
                  resfriado
                </label>
                <label>
                  <input
                    type="checkbox"
                    readOnly
                    checked={item?.condicaoAmostra === "AMBIENTE"}
                  />{" "}
                  ambiente
                </label>
              </div>
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={10}>
              24 - ANÁLISE(S) REQUERIDA(S) - CÓDIGO(S)
            </td>
          </tr>

          <tr>
            <td
              className={styles.fieldValue}
              colSpan={10}
              style={{ height: 20 }}
            >
              {item?.itens.map((e) => e.ensaio.nome).join(", ") || ""}
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={10}>
              25 - LABORATÓRIO
            </td>
          </tr>

          <tr>
            <td
              className={styles.fieldValue}
              colSpan={10}
              style={{ height: 20 }}
            >
              {item?.laboratorio?.nome || ""}
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={10}>
              26 - OBSERVAÇÕES
            </td>
          </tr>

          <tr>
            <td
              className={styles.fieldValue}
              colSpan={10}
              style={{ height: 20 }}
            >
              <p>{item?.observacaoColeta}</p>
              <p>
                OS RESULTADOS DEVERÃO SER ENCAMINHADOS SOMENTE AO E-MAIL
                cispoa@indea.mt.gov.br
              </p>
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={5}>
              27 - ASSINATURA E IDENTIFICAÇÃO DO RESPONSÁVEL PELA COLETA
            </td>

            <td className={styles.fieldLabel} colSpan={5}>
              28 - ASSINATURA E IDENTIFICAÇÃO DO RESPONSÁVEL PELO
              ESTABELECIMENTO
            </td>
          </tr>

          <tr>
            <td colSpan={5}>
              <div style={{ height: 100, textAlign: "center" }}>
                {item?.assinaturaServidor && (
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                    src={item?.assinaturaServidor}
                    alt="Assinatura Responsavel pela coleta"
                  />
                )}
              </div>
            </td>

            <td colSpan={5}>
              <div style={{ height: 100, textAlign: "center" }}>
                {item?.statusAssinaturaFiscalizado === "AUSENTE" && (
                  <span style={{ fontWeight: "bold" }}>AUSENTE</span>
                )}

                {item?.statusAssinaturaFiscalizado === "IMPOSSIBILITADO" && (
                  <span style={{ fontWeight: "bold" }}>IMPOSSIBILITADO</span>
                )}

                {item?.statusAssinaturaFiscalizado === "NAO_ALFABETIZADO" && (
                  <span style={{ fontWeight: "bold" }}>NAO ALFABETIZADO</span>
                )}

                {item?.statusAssinaturaFiscalizado === "RECUSADO" && (
                  <span style={{ fontWeight: "bold" }}>RECUSADO</span>
                )}

                {item?.assinaturaFiscalizado && (
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                    src={item?.assinaturaFiscalizado}
                    alt="Assinatura Responsavel pelo estabelecimento"
                  />
                )}
              </div>
            </td>
          </tr>

          <tr>
            <td colSpan={5} className={styles.fieldValue}>
              <strong>NOME:</strong> {item?.responsavelColeta?.nome || ""}
            </td>

            <td colSpan={5} className={styles.fieldValue}>
              <strong>NOME:</strong> {item?.nomeAssinanteFiscalizado || ""}
            </td>
          </tr>

          <tr>
            <td colSpan={5} className={styles.fieldValue}>
              <strong>MATRICULA:</strong>{" "}
              {item?.responsavelColeta?.matricula || ""}
            </td>

            <td colSpan={5} className={styles.fieldValue}>
              <strong>CPF:</strong>{" "}
              {cpfMask(item?.cpfAssinanteFiscalizado || "")}
            </td>
          </tr>

          <tr>
            <td colSpan={5} className={styles.fieldValue}>
              <strong>CARGO:</strong>{" "}
              {item?.responsavelColeta?.funcao?.nome || ""}
            </td>

            <td colSpan={5} className={styles.fieldValue}>
              <strong>FUNÇÃO:</strong> {item?.funcaoAssinanteFiscalizado || ""}
            </td>
          </tr>

          <tr>
            <td
              className={styles.labSectionTitle}
              colSpan={10}
              style={{ textAlign: "center" }}
            >
              CAMPOS DESTINADOS PARA USO EXCLUSIVO DO LABORATÓRIO
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={3}>
              29 - DATA DO RECEBIMENTO DA AMOSTRA
            </td>
            <td className={styles.fieldLabel} colSpan={3}>
              30 - HORÁRIO DO RECEBIMENTO DA AMOSTRA
            </td>
            <td className={styles.fieldLabel} colSpan={4}>
              31 - Nº DO REGISTRO NO LABORATÓRIO
            </td>
          </tr>

          <tr>
            <td
              className={styles.fieldValue}
              colSpan={3}
              style={{ height: 20 }}
            >
              <div style={{ minHeight: 14 }}>
                {" "}
                {item?.dataRecebimento
                  ? dayjs(item?.dataRecebimento).format("DD/MM/YYYY")
                  : ""}
              </div>
            </td>
            <td className={styles.fieldValue} colSpan={3}>
              {" "}
              {item?.dataRecebimento
                ? dayjs(item?.dataRecebimento).format("HH:mm")
                : ""}
            </td>
            <td className={styles.fieldValue} colSpan={4}>
              {item?.numeroRegistroLaboratorio || ""}
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={2}>
              32 - TEMPERATURA NO RECEBIMENTO
            </td>

            <td className={styles.fieldLabel} colSpan={8}>
              33 - CONDIÇÕES DA AMOSTRA NO RECEBIMENTO
            </td>
          </tr>

          <tr>
            <td
              className={styles.fieldValue}
              colSpan={2}
              style={{ height: 20 }}
            ></td>
            <td className={styles.fieldValue} colSpan={8}>
              <div className={styles.checkboxes}>
                <label>
                  <input type="checkbox" /> congelado
                </label>
                <label>
                  <input type="checkbox" /> cristais de gelo
                </label>
                <label>
                  <input type="checkbox" /> resfriado
                </label>
                <label>
                  <input type="checkbox" /> ambiente
                </label>
              </div>
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={10}>
              34 - OBSERVAÇÃO
            </td>
          </tr>

          <tr>
            <td className={styles.fieldValue} colSpan={10}>
              <div style={{ minHeight: 60 }}>
                {item?.observacaoRecebimento || ""}
              </div>
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={10}>
              35 - ASSINATURA E IDENTIFICAÇÃO DO RESPONSÁVEL PELO RECEBIMENTO
            </td>
          </tr>

          <tr>
            <td colSpan={10}>
              <div style={{ minHeight: 80 }}>
                {false && <img alt="assinatura" />}
              </div>
            </td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td className={styles.footer} colSpan={10}>
              Revisão: 02 - Edição: 11/07/2025
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <div className={styles.pageBreak}></div>

    {/* Second Page */}
    <div className={styles.secondPage}>
      {/* Header Section - Second Page */}
      <table className={styles.headerTable}>
        <thead>
          <tr>
            <th className={styles.logoSection}>
              <div className={styles.logo}>
                <img
                  src={brasaoImpressaoBase64}
                  alt="brasao"
                  style={{
                    width: 125,
                  }}
                />
              </div>
            </th>

            <th className={styles.instituteInfo}>
              <h1>INSTITUTO DE DEFESA AGROPECUÁRIA DO ESTADO DE MATO GROSSO</h1>

              <p>
                Rua Dep. José Alves Ribeiro, 1267 - Centro Político
                Administrativo | CEP: 78049-903 | Cuiabá - MT (65) 3613-6074
              </p>

              <h1>REQUISIÇÃO DE ANÁLISES LABORATORIAIS</h1>
            </th>

            <th className={styles.sectorInfo} style={{ width: "50%" }}>
              <div
                style={{
                  borderBottom: "1px solid black",
                  paddingLeft: "5px",
                  textAlign: "start",
                }}
              >
                <span>35 - SETOR</span>
              </div>
              <div
                className={styles.analysisTypes}
                style={{ borderBottom: "1px solid black", paddingBottom: 5 }}
              >
                <label>
                  <input
                    type="checkbox"
                    readOnly
                    checked={item?.natureza === "MICROBIOLOGICA"}
                  />{" "}
                  Microbiologia
                </label>
                <label>
                  <input
                    type="checkbox"
                    readOnly
                    checked={item?.natureza === "FISICOQUIMICO"}
                  />{" "}
                  Físico-Química
                </label>
                <label>
                  <input type="checkbox" readOnly /> RBQL
                </label>
              </div>

              <div className={styles.requestNumber}>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    textAlign: "start",
                    paddingLeft: "5px",
                  }}
                >
                  <span>36 - Nº DA SOLICITAÇÃO/ANO</span>
                </div>

                <div style={{ paddingTop: 5 }}>
                  <span>{item?.codigo}</span>
                </div>
              </div>
            </th>
          </tr>
        </thead>
      </table>

      {/* Second Page Content */}
      <table className={styles.dataTable}>
        <colgroup>
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
        </colgroup>
        <tbody>
          <tr>
            <td className={styles.fieldLabel} colSpan={4}>
              37 - PRODUTO
            </td>

            <td className={styles.fieldLabel} colSpan={4}>
              38 - INFORMAÇÕES ADICIONAIS
            </td>

            <td className={styles.fieldLabel} colSpan={2}>
              39 - LACRE
            </td>
          </tr>

          <tr>
            <td className={styles.fieldValue} colSpan={4}>
              {item?.agua ? "Água" : item?.produto?.produto?.nome || ""}
            </td>

            <td className={styles.fieldValue} colSpan={4}>
              {item?.infAdicional || ""}
            </td>

            <td className={styles.fieldValue} colSpan={2}>
              {item?.lacre || ""}
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={10}>
              40 - ANÁLISE(S) REQUERIDA(S) - CÓDIGO(S)
            </td>
          </tr>

          <tr>
            <td className={styles.fieldValue} colSpan={10}>
              {item?.itens.map((e) => e.ensaio.nome).join(", ") || ""}
            </td>
          </tr>

          <tr>
            <td className={styles.fieldLabel} colSpan={10}>
              41 - ASSINATURA E IDENTIFICAÇÃO DO RESPONSÁVEL PELA COLETA
            </td>
          </tr>

          <tr>
            <td className={styles.fieldValue} colSpan={10}>
              <div style={{ minHeight: 80, textAlign: "center" }}>
                {item?.assinaturaServidor && (
                  <img
                    style={{
                      width: "50%",
                      height: "50%",
                      objectFit: "contain",
                    }}
                    src={item?.assinaturaServidor}
                    alt="Assinatura Responsavel pela coleta"
                  />
                )}
              </div>
            </td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td className={styles.footer} colSpan={10}>
              Revisão: 02 - Edição: 11/07/2025
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
));
